export class FileEncrypted extends Error {
  constructor() {
    super('Esse arquivo está criptografado')
    this.name = 'FileEncrypted'
  }
}
